<template>
	<div class="financialStatement">
		<Header></Header>
		<div class="container">
			<div class="main_wrapper">
				<div v-for="(note,index) in this.notes" :key="index+'564'">
					<h1 class="gray mb-10" data-aos="fade-up">{{note.title}}</h1>
					<div class="date" data-aos="fade-up">{{note.date}}</div>
					<div data-aos="fade-up" class="gray" v-for="(text,index) in note.contents" :key="index+'568464'" v-html="text"></div>
					<div data-aos="fade-up" class="gray" v-for="(text,index) in note.contents2" :key="index+'6259'" v-html="text"></div>
					<div data-aos="fade-up" class="gray" v-html="note.heading"></div>
					<div data-aos="fade-up" class="gray" v-html="note.text"></div>
					<div class="table-wrapper on-991" v-if="note.table">
						<div class="custom-table">
							<div class="trow table-tp-head first_row">
								<div class="th text-left" v-for="(head,index) in note.table.head" :key="index+'asdffg'">{{head}}</div>
							</div>
							<div class="trow" v-for="(row,index) in note.table.rows" :key="index+'354265456'">
								<div v-for="(col,index) in row" :key="index+'2465404'">
									<p class="table_elements" v-html="col"></p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-for="(tableNote,index) in notesTable" :key="index+'kisadm'">
					<div class="table-wrapper on-991" v-if="tableNote.secTable" data-aos="fade-up">
						<div class="custom-table">
							<div class="trow table-tp-head first_row">
								<div class="th text-left" v-for="(head,index) in tableNote.secTable.head" :key="index+'650247'">{{head}}</div>
							</div>
							<div class="trow" v-for="(row,index) in tableNote.secTable.rows" :key="index+'v24hdfs'">
								<div v-for="(col,index) in row" :key="index+'26565468046'">
									<p class="table_elements" v-html="col"></p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-for="(tableNote,index) in notesTable3" :key="index+'265460460'">
					<div class="table-wrapper" v-if="tableNote.Table">
						<div class="custom-table ">
							<div class="trow table-tp-head first_row">
								<div class="th text-left" v-for="(head,index) in tableNote.Table.head" :key="index+'36205065605'">{{head}}</div>
							</div>
							<div class="trow" v-for="(row,index) in tableNote.Table.rows" :key="index+'2450a54f'">
								<div v-for="(col,index) in row" :key="index+'asdfa0565'">
									<p class="table_elements" v-html="col"></p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-for="(content,index) in text" :key="index+'2404dsf54'">
					<h4 class="gray">{{content.title}}</h4>
					<div v-for="(text,index) in content.contents" :key="index+'0646asdf4'" v-html="text"></div>
					<div class="table-wrapper" v-if="content.Table">
						<div class="custom-table">
							<div class="trow bdr-top" v-for="(row,index) in content.Table.rows" :key="index+'5adf60df'">
								<div v-for="(col,index) in row" :key="index+'6ad45sf59a'">
									<p class="table_elements" v-html="col"></p>
								</div>
							</div>
						</div>
					</div>
					<div class="gray" v-for="(text,index) in content.contnt" :key="index+'adf34adsf'" v-html="text"></div>
				</div>
				<div v-for="(tableNote,index) in customTable" :key="index+'asfd0f46'">
					<h4 class="gray">{{tableNote.title}}</h4>
					<p class="gray">{{tableNote.subTitle}}</p>
					<FirstTable />
					<FirstSubTable /> </div>
				<div v-for="(note,index) in texts" :key="index+'adsf304daf'">
					<div v-for="(text,index) in note.para" :key="index+'ds5f41f'" v-html="text"></div>
				</div>
				<h3 class="gray">{{medTexts[0].heading_text}}</h3>
				<p>{{medTexts[0].para_text_arabic}}</p>
				<SecTable />
				<h3 class="gray">{{medTexts[0].heding_two_text}}</h3>
				<p>{{medTexts[0].small_para}}</p>
				<ThirdTable />
				<div v-html="medTexts[0].para_two"></div>
				<ForthTable />
				<h3 class="gray">{{medTexts[0].heading_two}}</h3>
				<FifthTable />
				<h3 class="gray">{{medTexts[0].heading_three}} </h3>
				<SixTable />
				<p>{{medTexts[0].para_three}}</p>
				<SevenTable />
				<h3 class="gray">{{medTexts[0].heading_four}}</h3>
				<div v-for="(note,index) in medTexts" :key="index+'0654fasd65f4'">
					<div v-for="(text,index) in note.para" :key="index+'ads5f4ads620f4'" v-html="text"></div>
				</div>
				<div v-html="medTexts[0].heading_text_two"></div>
				<EightTable />
				<p class="skyBlue">{{medTexts[0].para_four}}</p>
				<NineTable />
				<div v-html="medTexts[0].heading_text_three"></div>
			</div>
			<h3 class="gray">{{medTexts[0].heading_five}}</h3>
			<TenTable />
			<div v-html="medTexts[0].heading_text_four"></div>
			<h3 class="gray">{{medTexts[0].heading_six}} </h3>
			<ElevenTable />
			<div v-html="medTexts[0].heading_para_five"></div>
			<TwelveTable />
			<div v-html="medTexts[0].heading_para_six"></div>
			<div v-for="(tableNote,index) in Impairmenttable" :key="index+'adf4a05sd4f'">
				<div class="table-wrapper" v-if="tableNote.secTable">
					<div class="custom-table ImpairmentTable">
						<div class="trow table-tp-head first_row">
							<div class="th" v-for="(head,index) in tableNote.secTable.head" :key="index+'65f6a5dsf40350'">{{head}}</div>
						</div>
						<div class="trow" v-for="(row,index) in tableNote.secTable.rows" :key="index+'d6asf52c6f40'">
							<div v-for="(col,index) in row" :key="index+'c52af4adf6'">
								<p class="table_elements" v-html="col"></p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-html="medTexts[0].heading_para_seven"></div>
			<ThirteenTable />
			<div v-html="medTexts[0].heading_para_eight"></div>
			<ForteenTable />
			<div v-html="medTexts[0].heading_para_nine"></div>
			<FifteenTable />
			<div v-html="medTexts[0].heading_para_ten"></div>
			<div v-for="(text,index) in first.section_one_text" :key="index+'2f7sdf'" v-html="text"></div>
			<SixteenTable />
			<div v-for="(text,index) in first.section_two_text" :key="index+'adsfdsf160'" v-html="text"></div>
			<SevenTeenTable />
			<div v-for="(text,index) in first.head15" :key="index+'fadfj650'" v-html="text"></div>
			<EighteenTable />
			<div v-for="(text,index) in first.head15_2" :key="index+'asdfadsf'" v-html="text"></div>
			<NinteenTable />
			<div v-for="(text,index) in first.section_three_text" :key="index+'asdadvfd24'" v-html="text"></div>
			<div class="gray" v-for="(text,index) in first.section_four_text" :key="index+'emdt4h2t'" v-html="text"></div>
			<TwentyTable />
			<div v-for="(text,index) in first.section_five_text" :key="index+'26et4h6ec4'" v-html="text"></div>
			<TwentyOneTable />
			<div class="gray" v-for="(text,index) in first.section_six_text" :key="index+'6r2y7h98yru'" v-html="text"></div>
			<TwentyTwoTable />
			<div v-for="(text,index) in first.section_seven_text" :key="index+'256f74865g4'" v-html="text"></div>
			<div class="gray" v-for="(text,index) in first.section_eight_text" :key="index+'mkgc5gh4'" v-html="text"></div>
			<TwentyThreeTable />
			<div class="gray" v-for="(text,index) in first.section_nine_text" :key="index+'v25g4r54t'" v-html="text"></div>
			<div class="gray" v-for="(text,index) in first.section_ten_text" :key="index+'65rgh7'" v-html="text"></div>
			<TwentyFourTable />
			<div v-for="(text,index) in first.section_eleven_text" :key="index+'654h'" v-html="text"></div>
			<div v-for="(text,index) in first.section_twelve_text" :key="index+'265v4g2h'" v-html="text"></div>
			<TwentyFiveTable />
			<div v-for="(text,index) in first.section_thirteen_text" :key="index+'265hty4h8ty'" v-html="text"></div>
			<TwentySixTable />
			<div v-for="(text,index) in first.section_fourteen_text" :key="index+'2vt4h94'" v-html="text"></div>
			<div class="gray" v-for="(text,index) in first.section_fifteen_text" :key="index+'63vh5'" v-html="text"></div>
			<div class="gray" v-for="(text,index) in first.section_sixteen_text" :key="index+'25vh4tyu'" v-html="text"></div>
			<TwentySevenTable />
			<div v-for="(text,index) in first.section_seventeen_text" :key="index+'v2g4'" v-html="text"></div>
			<TwentyEightTable />
			<div v-for="(text,index) in first.section_eighteen_text" :key="index+'24hbj'" v-html="text"></div>
			<div v-for="(text,index) in first.section_nineteen_text" :key="index+'256b4f'" v-html="text"></div>
			<TwentyNineTable />
			<div v-for="(text,index) in first.section_twenty_text" :key="index+'6brj4cr'" v-html="text"></div>
			<div v-for="(text,index) in first.section_twentyone_text" :key="index+'b2h4e'" v-html="text"></div>
			<ThirtyTable />
			<div v-for="(text,index) in first.section_twentytwo_text" :key="index+'265b4yh'" v-html="text"></div>
			<ThirtyOneTable />
			<ThirtyTwoTable />
			<div v-for="(text,index) in first.section_twentythree_text" :key="index+'bg4dh'" v-html="text"></div>
			<div v-for="(text,index) in first.section_twentyfour_text" :key="index+'2hb4gd5h'" v-html="text"></div>
			<ThirtyThreeTable />
			<div v-for="(text,index) in first.section_twentyfive_text" :key="index+'625bhdh'" v-html="text"></div>
			<ThirtyFourTable />
			<div v-for="(text,index) in first.section_twentysix_text" :key="index+'2v654vg2'" v-html="text"></div>
			<ThirtyFiveTable />
			<div v-for="(text,index) in first.section_twentyseven_text" :key="index+'vg25sg4'" v-html="text"></div>
			<div v-for="(text,index) in first.section_twentyeight_text" :key="index+'6v25e4cfr'" v-html="text"></div>
			<div class="table-wrapper tableOne" v-if="$i18n.locale=='en'">
				<div class="custom-table color_last">
					<div class="trow head table-tp-head">
						<div class="th">&nbsp;</div>
						<div class="th text-right">Amortized costs</div>
						<div class="th text-right">At fair value
							<br/>through profit
							<br/>or less</div>
						<div class="th text-right border-left-3">Fair value through
							<br/>comprehensive
							<br/>income</div>
					</div>
					<div class="trow head light-gray">
						<div class="th border-none">&nbsp;</div>
						<div class="th text-right no-border">KD ’000</div>
						<div class="th border-none no-border">&nbsp;</div>
					</div>
					<div class="trow" v-for="(data,index) in risk_table.table_one.rows" :key="index+'2c56fg4f685g4'">
						<div v-for="(value,index) in data" :key="index+'2v4ywtwr'">
							<p class="table_elements" v-html="value"></p>
						</div>
					</div>
				</div>
			</div>
            <div class="table-wrapper tableOne" v-if="$i18n.locale=='ar'">
				<div class="custom-table color_last">
					<div class="trow head table-tp-head">
						<div class="th">&nbsp;</div>
						<div class="th text-right">بالتكلفة المطفأة</div>
						<div class="th text-right">بالقيمة العادلة من 
							<br/>خلال بيان الربح أو 
							<br/>الخسارة</div>
						<div class="th text-right border-left-3">بالقيمة العادلة من 
							<br/>خلال الدخل الشامل 
							<br/>الآخر</div>
					</div>
					<div class="trow head light-gray">
						<div class="th border-none">&nbsp;</div>
						<div class="th text-right no-border">ألف دينار كويتي</div>
						<div class="th border-none no-border">&nbsp;</div>
					</div>
					<div class="trow" v-for="(data,index) in risk_table.table_one.rows" :key="index+'2654gv6r5g40'">
						<div v-for="(value,i) in data" :key="i+'2vh4jy'">
							<p class="table_elements" v-html="value"></p>
						</div>
					</div>
				</div>
			</div>
			<div class="table-wrapper tableOne on-767" v-if="$i18n.locale=='en'">
				<div class="custom-table color_last">
					<div class="trow head table-tp-head">
						<div class="th">&nbsp;</div>
						<div class="th text-right">Amortized costs</div>
						<div class="th text-right">At fair value
							<br/>through profit
							<br/>or less</div>
						<div class="th text-right border-left-3">Fair value through
							<br/>comprehensive
							<br/>income</div>
					</div>
					<div class="trow head light-gray">
						<div class="th border-none">&nbsp;</div>
						<div class="th text-right no-border">KD ’000</div>
						<div class="th border-none no-border">&nbsp;</div>
					</div>
					<div class="trow" v-for="(data,index) in risk_table.table_two.rows" :key="index+'2vg49rt'">
						<div v-for="(value,index) in data" :key="index+'625cf46a5df'">
							<p class="table_elements" v-html="value"></p>
						</div>
					</div>
				</div>
            </div>
            <div class="table-wrapper tableOne on-767" v-if="$i18n.locale=='ar'">
				<div class="custom-table color_last">
					<div class="trow head table-tp-head">
						<div class="th">&nbsp;</div>
						<div class="th text-right">بالتكلفة المطفأة</div>
						<div class="th text-right">بالقيمة العادلة من
                        <br/>خلال بيان الربح أو 
                        <br/>الخسارة</div>
						<div class="th text-right border-left-3">بالقيمة العادلة من
                        <br/>خلال الدخل الشامل 
                        <br/>الآخر</div>
					</div>
					<div class="trow head light-gray">
						<div class="th border-none">&nbsp;</div>
						<div class="th text-right no-border">ألف دينار كويتي</div>
						<div class="th border-none no-border">&nbsp;</div>
					</div>
					<div class="trow" v-for="(data,index) in risk_table.table_two.rows" :key="index+'2s6g4cs'">
						<div v-for="(value,index) in data" :key="index+'c2h4th'">
							<p class="table_elements" v-html="value"></p>
						</div>
					</div>
				</div>
            </div>
				<p>{{risk_table.table_two.headingTitle}}</p>
				<h4>{{risk_data.title}}</h4>
				<div v-html="risk_data.desc"></div>
				<div class="table-wrapper on-767" v-if="$i18n.locale=='en'">
					<div class="custom-table ligest">
						<div class="trow head table-tp-head">
							<div class="th">Currency</div>
							<div class="th text-right">&nbsp;</div>
							<div class="th text-center b-0 text-white font-weight-bold ligest-gray skyBlue bolder">2020</div>
							<div class="th text-center font-weight-bold">2019</div>
						</div>
						<div class="trow head light-gray">
							<div class="th border-none">&nbsp;</div>
							<div class="th text-right no-border">KD ’000</div>
							<div class="th border-none no-border">&nbsp;</div>
						</div>
						<div class="trow" v-for="(data,index) in section_two_table.table_one.rows" :key="index+'c2t64htey4h'">
							<div v-for="(value,index) in data" :key="index+'625f46h4tef'">
								<p class="table_elements" v-html="value"></p>
							</div>
						</div>
					</div>
				</div>
                <div class="table-wrapper on-767" v-if="$i18n.locale=='ar'">
					<div class="custom-table ligest">
						<div class="trow head table-tp-head">
							<div class="th">العملة</div>
							<div class="th text-right">&nbsp;</div>
							<div class="th text-center b-0 text-white font-weight-bold ligest-gray skyBlue bolder">2020</div>
							<div class="th text-center font-weight-bold">2019</div>
						</div>
						<div class="trow head light-gray">
							<div class="th border-none">&nbsp;</div>
							<div class="th text-right no-border">ألف دينار كويتي</div>
							<div class="th border-none no-border">&nbsp;</div>
						</div>
						<div class="trow" v-for="(data,index) in section_two_table.table_one.rows" :key="index+'tych304'">
							<div v-for="(value,index) in data" :key="index+'c624het'">
								<p class="table_elements" v-html="value"></p>
							</div>
						</div>
					</div>
				</div>
				<p v-for="(data,index) in section_two_table.data_text" :key="index+'23c8th6934y.h'">{{data}}</p>
				<div class="table-wrapper on-991" v-if="$i18n.locale=='en'">
					<div>
						<table>
							<thead>
								<tr class="dark-gray">
									<td><span class="invisible">asdf</span></td>
									<td class="text-center text-white font-weight-bold ligest-gray skyBlue bolder" colspan="2">2020</td>
									<td class="text-center text-white font-weight-bold" colspan="2">2019</td>
								</tr>
								<tr class="med-gray">
									<td class="text-white font-weight-bold">Market indices</td>
									<td class="text-right ligest-gray text-dark font-weight-bold">Impact on
										<br/> net profit</td>
									<td class="text-right ligest-gray text-dark font-weight-bold">Effect on
										<br/> equity</td>
									<td class="text-right text-white font-weight-bold">Impact on
										<br/> net profit</td>
									<td class="text-right text-white font-weight-bold">Effect on
										<br/> equity</td>
								</tr>
								<tr class="light-gray">
									<td colspan="3"><span class="invisible">asdf</span></td>
									<td colspan="2" class="text-center text-white font-weight-bold"> KD ’000</td>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td class="text-left">kuwait Stock Exchange</td>
									<td v-for="(data,index) in section_two_table.table_two" :key="index+'2g5245df4g'" class="text-right">{{data}}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="table-wrapper on-991" v-if="$i18n.locale=='ar'">
					<div>
						<table>
							<thead>
								<tr class="dark-gray">
									<td><span class="invisible">asdf</span></td>
									<td class="text-center text-white font-weight-bold ligest-gray skyBlue bolder" colspan="2">2020</td>
									<td class="text-center text-white font-weight-bold" colspan="2">2019</td>
								</tr>
								<tr class="med-gray">
									<td class="text-white font-weight-bold">مؤشرات السوق</td>
									<td class="text-right ligest-gray text-dark font-weight-bold">الأثر في صافي
										<br/>الربح</td>
									<td class="text-right ligest-gray text-dark font-weight-bold">الأثر في حقوق الملكية</td>
									<td class="text-right text-white font-weight-bold">الأثر في صافي
										<br/>الربح</td>
									<td class="text-right text-white font-weight-bold">الأثر في حقوق
										<br/>الملكية</td>
								</tr>
								<tr class="light-gray">
									<td colspan="3"><span class="invisible">asdf</span></td>
									<td colspan="2" class="text-center text-white font-weight-bold">ألف دينار كويتي</td>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td class="text-left">بورصة الكويت</td>
									<td v-for="(data,index) in section_two_table.table_two" :key="index+'2c7e68trh74'" class="text-right">{{data}}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div v-html="section_two_table.bigData"></div>
				<LastTable />
				<div v-html="section_two_table.lastonePra"></div>
				<SecondLast/>
				<div v-html="section_two_table.lastTwoPra"></div>
				<ThirdLast />
				<div v-html="section_two_table.lastThreeText"></div>
				<FourthLast />
				<div v-html="section_two_table.lastFourText"></div>
				<FifthLast />
				<div v-html="section_two_table.lastFiveText"></div>
				<Sixlast />
				<div v-for="(text,index) in second_last.text_data" :key="index+'28g74s6dfg4'" v-html="text"></div>
				<SevenLast />
				<div class="gray">
					<div v-for="(text,index) in second_last.section_two_text" :key="index+'gc24rthc'" v-html="text"></div>
					<div v-for="(text,index) in second_last.section_three_text" :key="index+'c62teh4h4'" v-html="text"></div>
				</div>
				<EightLast />
				<div class="gray">
					<div v-for="(text,index) in second_last.section_four_text" :key="index+'ch42c'" v-html="text"></div>
					
				</div>
				<NineLast />
                <div class="gray">
                    <div v-for="(text,index) in second_last.section_five_text" :key="index+'62h4vdgd'" v-html="text"></div>
                </div>
				<div class="gray">
					<div v-for="(text,index) in second_last.section_six_text" :key="index+'vj542yu'" v-html="text"></div>
					
				</div>
				<TenLast />
                <div class="gray">
                    <div v-for="(text,index) in second_last.section_seven_text" :key="index+'822j7gyj'" v-html="text"></div>
                </div>
				<div class="gray" v-for="(text,index) in lastText.lastContent" :key="index+'v254jrj'" v-html="text"></div>
			</div>
		</div>
</template>

<script>
// import sctionsScroll from "../../components/common/sectionsScroll.vue";
import util from '@/mixin/util.js';
import data from "@/components/financial/financial.json";
import "@/assets/sccs/finacial-statement.scss";
import FirstTable from "@/components/Fstatement/tablesData/en/FirstTable.vue";
import FirstSubTable from "@/components/Fstatement/tablesData/en/FirstSubTable.vue";
import SecTable from "@/components/Fstatement/tablesData/en/SecTable.vue";
import ThirdTable from "@/components/Fstatement/tablesData/en/ThirdTable.vue";
import ForthTable from "@/components/Fstatement/tablesData/en/ForthTable.vue";
import FifthTable from "@/components/Fstatement/tablesData/en/FifthTable.vue";
import SixTable from "@/components/Fstatement/tablesData/en/SixTable.vue";
import SevenTable from "@/components/Fstatement/tablesData/en/SevenTable.vue";
import EightTable from "@/components/Fstatement/tablesData/en/EightTable.vue";
import NineTable from "@/components/Fstatement/tablesData/en/NineTable.vue";
import TenTable from "@/components/Fstatement/tablesData/en/TenTable.vue";
import ElevenTable from "@/components/Fstatement/tablesData/en/ElevenTable.vue";
import TwelveTable from "@/components/Fstatement/tablesData/en/TwelveTable.vue";
import ThirteenTable from "@/components/Fstatement/tablesData/en/ThirteenTable.vue";
import ForteenTable from "@/components/Fstatement/tablesData/en/ForteenTable.vue";
import FifteenTable from "@/components/Fstatement/tablesData/en/FifteenTable.vue";
import SixteenTable from "@/components/Fstatement/tablesData/en/SixteenTable.vue";
import SevenTeenTable from "@/components/Fstatement/tablesData/en/SevenTeenTable.vue";
import EighteenTable from "@/components/Fstatement/tablesData/en/EighteenTable.vue";
import NinteenTable from "@/components/Fstatement/tablesData/en/NinteenTable.vue";
import TwentyTable from "@/components/Fstatement/tablesData/en/TwentyTable.vue";
import TwentyOneTable from "@/components/Fstatement/tablesData/en/TwentyOneTable.vue";
import TwentyTwoTable from "@/components/Fstatement/tablesData/en/TwentyTwoTable.vue";
import TwentyThreeTable from "@/components/Fstatement/tablesData/en/TwentyThreeTable.vue";
import TwentyFourTable from "@/components/Fstatement/tablesData/en/TwentyFourTable.vue";
import TwentyFiveTable from "@/components/Fstatement/tablesData/en/TwentyFiveTable.vue";
import TwentySixTable from "@/components/Fstatement/tablesData/en/TwentySixTable.vue";
import TwentySevenTable from "@/components/Fstatement/tablesData/en/TwentySevenTable.vue";
import TwentyEightTable from "@/components/Fstatement/tablesData/en/TwentyEightTable.vue";
import TwentyNineTable from "@/components/Fstatement/tablesData/en/TwentyNineTable.vue";
import ThirtyTable from "@/components/Fstatement/tablesData/en/ThirtyTable.vue";
import ThirtyOneTable from "@/components/Fstatement/tablesData/en/ThirtyOneTable.vue";
import ThirtyTwoTable from "@/components/Fstatement/tablesData/en/ThirtyTwoTable.vue";
import ThirtyThreeTable from "@/components/Fstatement/tablesData/en/ThirtyThreeTable.vue";
import ThirtyFourTable from "@/components/Fstatement/tablesData/en/ThirtyFourTable.vue";
import ThirtyFiveTable from "@/components/Fstatement/tablesData/en/ThirtyFiveTable.vue";
import LastTable from "@/components/Fstatement/tablesData/en/lastTableone.vue";
import SecondLast from "@/components/Fstatement/tablesData/en/Secondlast.vue";
import ThirdLast from "@/components/Fstatement/tablesData/en/ThirdLasttable.vue";
import FourthLast from "@/components/Fstatement/tablesData/en/ForthLast.vue";
import FifthLast from "@/components/Fstatement/tablesData/en/FifthLast.vue";
import Sixlast from "@/components/Fstatement/tablesData/en/SixthLast.vue";
import SevenLast from "@/components/Fstatement/tablesData/en/SevenLast.vue";
import EightLast from "@/components/Fstatement/tablesData/en/EightLast.vue";
import NineLast from "@/components/Fstatement/tablesData/en/NineLast.vue";
import TenLast from "@/components/Fstatement/tablesData/en/TenLast.vue";
export default {
    mixins: [util],
    components:{
        FirstTable,
        FirstSubTable,
        SecTable,
        ThirdTable,
        ForthTable,
        FifthTable,
        SixTable,
        SevenTable,
        EightTable,
        NineTable,
        TenTable,
        ElevenTable,
        TwelveTable,
        ThirteenTable,
        ForteenTable,
        FifteenTable,
        SixteenTable,
        SevenTeenTable,
        EighteenTable,
        NinteenTable,
        TwentyTable,
        TwentyOneTable,
        TwentyTwoTable,
        TwentyThreeTable,
        TwentyFourTable,
        TwentyFiveTable,
        TwentySixTable,
        TwentySevenTable,
        TwentyEightTable,
        TwentyNineTable,
        ThirtyTable,
        ThirtyOneTable,
        ThirtyTwoTable,
        ThirtyThreeTable,
        ThirtyFourTable,
        ThirtyFiveTable,
        LastTable,
        SecondLast,
        ThirdLast,
        FourthLast,
        FifthLast,
        Sixlast,
        SevenLast,
        EightLast,
        NineLast,
        TenLast    
         // sctionsScroll
    },
    data(){
        return{
            // notes: data,
            // notesTable: data,
            // notesTable3: data,
            // text: data,
            // customTable: data,
            // texts:data,
            // medTexts:data,
            // Impairmenttable: data,
            // first:data,
            // second_last:data,
            // lastText: data,
            // risk_table: data,
            // risk_data: data,
            // section_two_table: data,
            // first:data,
            // second_last:data,
            // lastText: data,
            data: data,
            reneomNumber:this.rendomNumber()
        }
    },
    methods : {
        rendomNumber(){
            return new Date().getTime() / 1000;
        }
    },
    mounted(){
        // console.log(this.texts,"testttttt")
        // console.log(this.rendomNumber())
        // this.rendomNumber();
        // console.log("this", notesTable[0].secTable);

    },
    created(){
        if(this.$i18n.locale=="en"){
            this.notes = this.data.en.notes,
            this.notesTable = this.data.en.notesTable,
            this.notesTable3 = this.data.en.notesTable3,
            this.text = this.data.en.text,
            this.customTable = this.data.en.customTable,
            this.texts = this.data.en.texts,
            this.medTexts = this.data.en.medTexts,
            this.Impairmenttable = this.data.en.Impairmenttable,
            this.first = this.data.en.lastText.firstData,
            this.second_last = this.data.en.lastText.section_two,
            this.lastText = this.data.en.lastText,
            this.risk_table = this.data.en.risk_management[0].table,
            this.risk_data = this.data.en.risk_management[0].text_data,
            this.section_two_table = this.data.en.risk_management[0].table_section_two,
            this.first = this.data.en.lastText.firstData,
            this.second_last = this.data.en.lastText.section_two,
            this.lastText = this.data.en.lastText
            
        }
        else{
            this.notes=this.data.ar.notes,
            this.notesTable=this.data.ar.notesTable,
            this.notesTable3=this.data.ar.notesTable3,
            this.text=this.data.ar.text,
            this.customTable=this.data.ar.customTable,
            this.texts=this.data.ar.texts,
            this.medTexts=this.data.ar.medTexts,
            this.Impairmenttable=this.data.ar.Impairmenttable,
            this.first=this.data.ar.lastText.firstData,
            this.second_last=this.data.ar.lastText.section_two,
            this.lastText=this.data.ar.lastText,
            this.risk_table=this.data.ar.risk_management[0].table,
            this.risk_data=this.data.ar.risk_management[0].text_data,
            this.section_two_table=this.data.ar.risk_management[0].table_section_two,
            this.first=this.data.ar.lastText.firstData,
            this.second_last=this.data.ar.lastText.section_two,
            this.lastText=this.data.ar.lastText
            
        }
    }

}
</script>
